<template>
  <section class="shoppingMall">

    <nav :class="{'isShowNav':isShowNav}">
      <div class="typeBox">
        <div class="addType2" @click="addTypeClick"></div>
        <swiper :options="myAddTypeOption" class="styleNavSwiper f28 t_center">
          <swiper-slide
          v-for="(item,index) in addTypeList"
          :key="index"
          class="slideItem oneClamp"
          :class="{'active':addTypeIndex === index}"
          @click.native="changeStyleNav(index)"
          >{{item.tagName}}</swiper-slide>
        </swiper>
      </div>
	  </nav>

    <!--轮播图-->
    <div class="swiperWrap">
      <swiper :options="swiperOption" ref="mySwiper" class="mySwiper">
        <swiper-slide v-for="(item,index) in bannerList" :key="index" class="slideItem">
          <img :src="'/images/home/'+item.bannerPic" align="middle">
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>

    <div class="tips"></div>
    <div class="area">

      <div class="areaOne" v-if='newTopList.length!==0'>
        <div class="content" @click="toTopNew">
          <div class="newTitle">
            <div class="name">定时上新</div>
            <div class="time">{{countDownTime}}</div>
          </div>
          <div class="shopBox">
            <img align="middle" :src="newTopList[0].baseProductPics[0] | formatImgUrl(148,148,true)">
            <img align="middle" v-if='newTopList.length>1' :src="newTopList[1].baseProductPics[0] | formatImgUrl(148,148,true)">
          </div>
        </div>

        <div class="line"></div>

        <div class="content" @click="toChangeBag">
          <div class="newTitle">
            <div class="name">换背专区<span>&#x3000;会员全场随意换！</span></div>
          </div>
          <div class="shopBox">
            <img align="middle" :src="changeBagList[0].baseProductPics[0] | formatImgUrl(148,148,true)">
            <img align="middle" :src="changeBagList[1].baseProductPics[0] | formatImgUrl(148,148,true)">
          </div>
        </div>

      </div>

      <div class="areaOne" v-if='newTopList.length===0'>
        <div class="content contentTwo" @click="toChangeBag">
          <div class="newTitle">
            <div class="name">换背专区</div>
            <div class="describe">会员全场随意换</div>
          </div>
          <div class="shopBox" v-if="changeBagList.length>=4">
            <img align="middle" :src="changeBagList[0].baseProductPics[0] | formatImgUrl(148,148,true)">
            <img align="middle" :src="changeBagList[1].baseProductPics[0] | formatImgUrl(148,148,true)">
            <img align="middle" :src="changeBagList[2].baseProductPics[0] | formatImgUrl(148,148,true)">
            <img align="middle" :src="changeBagList[3].baseProductPics[0] | formatImgUrl(148,148,true)">
          </div>
        </div>
      </div>


    </div>

    <!--让你在不同场合闪耀 -->
    <section class="selectedStyle">
      <!-- <div class="title" @click="toProList">
        <div>让你在不同场合闪耀</div>
				<div style="display:none"></div>
				<div>详情</div>
      </div> -->
      <div class="typeBox">
        <div class="addType" @click="addTypeClick"></div>
        <swiper :options="myAddTypeOption" class="styleNavSwiper f28 t_center">
        <swiper-slide
          v-for="(item,index) in addTypeList"
          :key="index"
          class="slideItem oneClamp"
          :class="{'active':addTypeIndex === index}"
          @click.native="changeStyleNav(index)"
        >{{item.tagName}}</swiper-slide>
      </swiper>
      </div>

      <van-list
        v-model="isLoading"
        :finished="isFinished"
        finished-text=" "
        v-if="tagList.length>0"
        :offset="100"
        :immediate-check="false"
        @load="getTagList"
      >
        <ul class="proList">
          <li v-for="(item,index) in tagList" :key="index">
            <pro-info-card :item="item"/>
          </li>
        </ul>
      </van-list>
      <router-link v-if="isFinished" :to="{ name: 'proList'}" style="width:100px;margin:0 auto;height:100px;display: block;text-align: center;">查看更多</router-link>
    </section>

    <div class="keFuIcon" @click="$showKeFuPopup">
      <img src="/images/home/ke_fu_icon.png" align="middle">
    </div>

    <my-popup ref="addTypePopup" cancelText="完成" @cancelClick='refreshTagBoard'>
      <section class="addTypePopup">

        <section class="addTypeBox" v-for='(item,index) in tagBoard' :key='index'>
          <div class="addTitle">{{item.tagType.show}}</div>
          <div class="content">
            <div  v-for='(itemTwo,indexTwo) in item.tags' :key='indexTwo'
              class="box"
              :class="[itemTwo.isCollect?(itemTwo.strLength<10?'boxWidthOne boxActive':'boxActive boxWidthTwo'):(itemTwo.strLength<10?'boxWidthOne':'boxWidthTwo')]"
              @click="tagBoardClick(itemTwo.id,itemTwo.isCollect,index,indexTwo)"
              >{{itemTwo.name}}</div>
          </div>
        </section>

      </section>
    </my-popup>

  </section>
</template>



<script>
import { mapState, mapActions } from "vuex";
import homeApi from "@api/home";
import myApi from '@api/my';
import CollectCom from "../../../components/collectCom";
import publicObj from "@utils/public";
import {  setInterval, clearInterval } from "timers";
export default {
  name: "index",
  components: { CollectCom },
  data() {
    return {
      isShowNav:false,
      //现在时间的时间戳
      nowTimeStr:new Date().getTime(),
      //上新列表
      newTopList:[],
      //上新时间轴
      timeList:[],
      timeListIndex:0,
      timeDay:'',
      swiperOption: {
        loop: true,
        spaceBetween: 6,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        pagination: {
          el: ".swiper-pagination"
          // type: 'progressbar',
        },
        on: {
          tap: () => {
            //诸葛：首页-点击首页banner
            let num=this.mySwiper.realIndex+1
            zhuge.track("首页-点击首页banner", {
              "banner名称":"banner"+num
            });
            const item = this.bannerList[this.mySwiper.realIndex];
            console.log()
            this.$router.push({
              name: item.pathName,
              params: { id: item.params }
            });
          }
        }
      },
      bannerList: [
        { pathName: "changeBag", bannerPic: "zjb_banner1.jpg" },
        { pathName: "sceneDetail", bannerPic: "zjb_banner2.png", params: 1 },
        { pathName: "sceneDetail", bannerPic: "zjb_banner3.jpg", params: 2 }
      ],
      // { pathName: "sceneDetailProcess", bannerPic: "banner_01.png" },
      //   { pathName: "sceneDetail", bannerPic: "newbanner02.jpg", params: 1 },
      //   { pathName: "sceneDetail", bannerPic: "newbanner03.jpg", params: 2 }
      //我的标签
      myAddTypeOption: {
        slidesPerView: "auto",
        spaceBetween: 24,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20
      },
      //换背列表
      changeBagList: [],
      //热门品牌
      hotBrandList: [
        { name: "Louis Vuitton", pic: "brand_01" },
        { name: "Chanel", pic: "brand_02" },
        { name: "Gucci", pic: "brand_03" },
        { name: "Dior", pic: "brand_04" },
        { name: "Fendi", pic: "brand_05" },
        { name: "Saint Laurent Paris", pic: "brand_06" },
        { name: "Chloe", pic: "brand_07" },
        { name: "Prada", pic: "brand_08" },
        { name: "Balenciaga", pic: "brand_09" }
      ],
      //自己的标签对应的列表
      tagListConfig: {
        pageNum: 1,
        pageSize: 8,
        total: 0
      },
      isLoading: false,
      isFinished: false,
      //自己的标签
      addTypeIndex:0,
      addTypeList:[],
      //标签对应下的商品
      tagList:[],
      //弹窗的标签列表
      tagBoard:[],
      //上新倒计时
      countDownTime:'',
      timer:null
    };
  },
  computed: {
    ...mapState({
      // categoryList:state => state.attributes.categoryList,
      saleTypeObj: "saleTypeObj",
      serviceObj: "serviceObj",
      isBottomNav: "isBottomNav",
      userInfo: state => state.user.userInfo
    }),
    mySwiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  created() {
    this.getAddTypeListFn()
    this.getChangeBagList()
    this.getTopNew();
    //诸葛：首页-进入首页
    zhuge.track("首页-进入首页");

  },
  mounted() {
      window.addEventListener('scroll',this.onScroll)
  },
  activated() {
  },
  destroyed () {
      window.removeEventListener('scroll', this.onScroll)
    },
  methods: {
    ...mapActions({
      addViewHistory: "user/addViewHistory",
      changeFooterNav:"changeFooterNav"
    }),

    onScroll() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop

        if (scrollTop > 470 ) {
          this.isShowNav = true
        }else {
          this.isShowNav = false
        }
		},

    refreshTagBoard(){
      // this.changeFooterNav()
      let idArr=[],tagBoard=this.tagBoard
      for(let i=0;i<tagBoard.length;i++){
          for(let j=0;j<tagBoard[i].tags.length;j++){
            if(tagBoard[i].tags[j].isCollect){
              idArr.push(tagBoard[i].tags[j].id)
            }
          }
        }
      homeApi.collectTagBoard({tagIds:idArr}).then(()=>{
          this.getAddTypeListFn()
        }).then(()=>{
          this.getTagBoard()
        })
    },

    addTypeClick(){
      this.getTagBoard()
      this.$refs.addTypePopup.show()
      // this.changeFooterNav()
    },

    getTagBoard(){
      homeApi.getTagBoard().then(res=>{
        for(let i=0;i<res.length;i++){
          for(let j=0;j<res[i].tags.length;j++){
            res[i].tags[j].strLength=publicObj.getStrLen(res[i].tags[j].name)
          }
        }
        this.tagBoard=res
      })
    },

    tagBoardClick(id,isCollect,index,indexTwo){
      let list=this.tagBoard
      let tagTypeName=this.tagBoard[index].tagType.show
      let tagName=this.tagBoard[index].tags[indexTwo].name
      if(isCollect){
        //诸葛：首页-标签添加页添加&删除标签
        zhuge.track("首页-标签添加页-删除标签", {
          "标签分类":tagTypeName,
          "标签名称":tagName
        });

        for(let i=0;i<list.length;i++){
          for(let j=0;j<list[i].tags.length;j++){
            if(list[i].tags[j].id===id){
              list[i].tags[j].isCollect=false
            }
          }
        }

      }else{
        //诸葛：首页-标签添加页添加&删除标签
        zhuge.track("首页-标签添加页-添加标签", {
          "标签分类":tagTypeName,
          "标签名称":tagName
        });

        for(let i=0;i<list.length;i++){
          for(let j=0;j<list[i].tags.length;j++){
            if(list[i].tags[j].id===id){
              list[i].tags[j].isCollect=true
            }
          }
        }

      }
      this.tagBoard=list
    },

    //获取我的标签
    getAddTypeListFn(){
      this.getAddTypeList().then(res=>{
        this.addTypeList=res
      }).then(()=>{
        this.addTypeIndex=0
        this.getTagList()
      })
    },

    async getAddTypeList(){
      const data=await myApi.getAddTypeList()
      return data
    },

    //倒计时
    remindTimeFn(str){
      clearInterval(this.timer)
      this.countDownTime = publicObj.countDownTimeFn(str,"时:分:秒")
      this.timer = setInterval(() => {
        str = str - 1000
        this.countDownTime = publicObj.countDownTimeFn(str,"时:分:秒")
        if (str<=0) {
          this.countDownTime="抢购中..."
          clearInterval(this.timer);
          // this.getTopNew();
        }
      }, 1000);
    },

    getTopNew(params={}){
      homeApi.getTopNew(params).then(res=>{
        if(res){
          if(res.selectedPresaleTime){
            //倒计时
            let topNewTime = new Date(
                  res.selectedPresaleTime.replace(/-/g, "/")
                ).getTime(),
                nowTime=new Date().getTime()
                console.log("111",topNewTime-nowTime)
                if (nowTime < topNewTime) {
                  this.remindTimeFn(topNewTime-nowTime);
                }else{
                  this.countDownTime="抢购中..."
                }

        let data=res.dailyNewPresaleTimeDTOS
        for(let i=0;i<data.length;i++){
          let timeArr=data[i].sellTimeMinute.split(" ")[1].split(":")
          let time=timeArr[0]+":"+timeArr[1]
          data[i].time=time
          data[i].timeStr=new Date(data[i].sellTimeMinute.replace(/-/g,"/")).getTime()
          if(data[i].sellTimeMinute==res.selectedPresaleTime){
            this.timeListIndex=i
          }
        }
        this.timeList=data
      }
      let dateArr=(res.sellTimeDay.split(" ")[0]).split("-")
      this.timeDay=dateArr[1]+"."+dateArr[2]
      this.newTopList=res.productDTOS
        }else{
          this.newTopList=[]
        }
      })

    },

		//上新专区时间点击
			// timeClick(index,sellTimeMinute){
      //   this.timeListIndex=index
      //   this.getTopNew({selectedPresaleTime:sellTimeMinute})
      // },

      //  新版本
      changeStyleNav(index) {
      this.addTypeIndex = index;
      this.tagListConfig.pageNum = 1;
      this.isLoading = true;
      this.isFinished = false;
      this.getTagList();
    },

    //获取最新商品列表
    getChangeBagList() {
      this.getProList({
        // sortby:'syncTime',
        // order:'desc',
        saleType: 1,
        pageSize: 12
      }).then(res => {
        this.changeBagList = [...res.result];
      });
    },

    //获取对应款式商品列表(新版本)
      getTagList() {
      let tagId=this.addTypeList[this.addTypeIndex].tagId
      homeApi.getTagShop(tagId,{...this.tagListConfig}).then(res=>{
        if(tagId){
          this.tagListConfig.total = res.total;
          let list=[]
          if (this.tagListConfig.pageNum !== 1) {
          list = [...this.tagList];
          }
          this.isLoading = false;
          this.tagList = list.concat(res.result);
          if (
            this.tagList.length >=
            this.tagListConfig.total
          ) {
            this.isFinished = true;
          } else {
            this.tagListConfig.pageNum++;
          }

        }else{
          //id=0
          this.tagList = res
          this.isFinished = true

        }
      })
    },

    //获取商品列表
    async getProList(params = {}) {
      const { result, total } = await homeApi.getProList(params);
      return { result, total };
		},
		toTopNew(){
      // , query: { board: true }
			this.$router.push({ name: "topNew" });
    },

    //让你在不同的场合闪耀
    toProList(type, item) {
      if (type) {
        this.$router.push({ name: "proList", query: { [type]: item } });
      } else {
        this.$router.push({ name: "proList" });
      }
    },

    //进入换背页
    toChangeBag(){
      // , query: { board: true }
      this.$router.push({ name: "changeBag" });
    },

    //在这里，发现你心仪的包
    brandList() {
      this.$router.push({ name: "proList" , query: { board: true} });
    },
    toggleCollect($event, item) {
      item.isCollect = $event;
    }
  }
};
</script>

<style lang="scss" scoped>
.shoppingMall {
  /*顶部导航区*/
  nav{
	position: fixed;
	top:-100px;
	left: 0;
	width: 100%;
	height: 100px;
	z-index: 20;
	background: $white-color;
	box-shadow: $base-shadow;
	border-radius:0 0 20px 20px;
	box-sizing: border-box;
	transition: .5s ease-in-out;
	-webkit-transform: translateZ(0);
	&.isShowNav{
	  top: -1px;
	  }
  }

  /*轮播图*/
  .mySwiper {
    // height: 804px;
    /*margin-bottom: 60px;*/
    /*> .swiper-pagination-progressbar,*/
    /*> .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite{*/
    /*top: calc(804px - 12px);*/
    /*height: 12px;*/
    /*}*/
    .slideItem {
      /*<!--background: $brand-color;-->*/
      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .title {
    height: 40px;
    line-height: 40px;
    margin: 0 40px 0 0;
    padding: 60px 10px 60px 40px;
    background: url("/images/base/arrow_right_grey.png") no-repeat right center;
    background-size: 12px;
    div:nth-child(1) {
      float: left;
      font-size: 40px;
      font-weight:500;
    }
    div:nth-child(2) {
      float: left;
      width: 100px;
      height: 36px;
      box-sizing: border-box;
      padding-left: 8px;
      background: url("/images/home/orange_date.png") no-repeat;
      text-align: center;
      background-size: contain;
      font-weight:500;
      line-height: 36px;
      margin-left: 16px;
      color: white;
      overflow: hidden;
      .content{
        float: left;
      font-size: 24px;
      }
      span {
        width: 20px;
        display: block;
        float: left;
        margin-top: 2px;
        -webkit-transform: scale(0.7);
      }
    }
    div:nth-child(3) {
      float: right;
      font-size: 20px;
      margin-right: 12px;
      line-height: 44px;
      color: #666;
    }
  }

  .tips {
		width: 100%;
		height: 52px;
		background: url("/images/home/black_title.png") no-repeat;
		background-size: cover;
    margin: 16px auto 0px;
  }

  //定时上新&换背专区
  .area{
    width: 100%;
    height: 304px;
    padding-top: 38px;
    box-sizing: border-box;
    box-shadow:0px 2px 20px 0px rgba(0,0,0,0.1);
    border-radius:0px 0px 20px 20px;
    margin-bottom: 64px;
    .areaOne{
      width: 100%;
      height: 218px;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      .line{
        width: 6px;
        height: 100%;
        background-color: #FAFAFA;
      }
      .content{
        width: 306px;
        height: 100%;
        padding-top: 6px;
        box-sizing: border-box;
        font-weight:500;
        .newTitle{
          width: 100%;
          height: 40px;
          overflow: hidden;
          .name{
            float: left;
            font-size:32px;
            line-height:48px;
            span{
              font-size:18px;
              font-weight:400;
              color:rgba(153,153,153,1);
              line-height:30px;
            }
          }
          .time{
            float: right;
            width: 128px;
            height: 40px;
            background: url("/images/home/orange_date_left.png") no-repeat;
            background-size: contain;
            font-size:24px;
            color:rgba(255,255,255,1);
            line-height:42px;
            box-sizing: border-box;
            padding-right: 8px;
            text-align: right;
          }
          .describe{
            width:240px;
            padding-right: 26px;
            text-align: right;
            background-color: green;
            font-size:20px;
            color:rgba(51,51,51,1);
            line-height:40px;
            float: right;
            background: url("/images/base/arrow_right.png") no-repeat right center;
            background-size: 10px;
          }
        }
        .shopBox{
          width: 100%;
          height: 152px;
          margin-top: 20px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          img{
            width: 152px;
            height: 152px;
            border:2px solid rgba(250,250,250,1);
            overflow: hidden;
            box-sizing: border-box;
          }
        }
      }
      .contentTwo{
        width: 100%;
        padding: 0px 32px;
      }
    }
  }

  /*精选款式*/
  .selectedStyle,nav {
    .typeBox{
      width: 100%;
      height: 80px;
      margin-bottom: 38px;
      box-sizing: border-box;
      padding-left: 32px;
      position: relative;
      .addType{
        width: 80px;
        height: 80px;
        background-color: white;
        position: absolute;
        z-index: 2;
        box-shadow:0px 2px 20px 0px rgba(0,0,0,0.1);
        border-radius:8px 200px 200px 8px;
        overflow: hidden;
        background: url("/images/home/add_type.png") no-repeat center center;
        background-size: 38px;
      }
      .addType2{
        width: 70px;
        height: 52px;
        background-color: white;
        border-right: 4px solid #FAFAFA;
        position: absolute;
        z-index: 2;
        top: 18px;
        overflow: hidden;
        background: url("/images/home/add_type.png") no-repeat left center;
        background-size: 38px;
      }
    .styleNavSwiper {
      padding-top: 24px;
      margin-left: 80px;
      .slideItem {
        width: auto;
        display: inline-block;
        line-height: 42px;
        padding-bottom: 46px;
        /*transition: .3s;*/
      }
      .active {
        font-size: 32px;
        font-weight: bold;
        position: relative;
      }
      .active:after {
        @include navActive;
        left: 50%;
        top: 40px;
      }
    }
    }
    .proList {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 0 32px 0 32px;
      li {
        width: 308px;
      }
    }
  }

  .keFuIcon {
    position: fixed;
    right: 0;
    bottom: 208px;
    z-index: 9;
    img {
      width: 124px;
      height: 142px;
    }
  }
  .addTypePopup{
    box-sizing: border-box;
    padding: 56px 4px 40px 32px;
    font-weight:500;
    .addTypeBox{
      margin-top: 40px;
      .addTitle{
        margin-bottom: 32px;
        font-size:40px;
        line-height:40px;
      }
      .content{
        overflow: hidden;
        .boxWidthOne{
          width: 210px;
        }
        .boxWidthTwo{
          width: 328px;
        }
        .box{
          height: 56px;
          box-sizing: border-box;
          border-radius:8px;
          border:1px solid rgba(207,207,207,1);
          font-size:28px;
          font-weight:300;
          color:rgba(51,51,51,1);
          line-height:54px;
          text-align: center;
          float: left;
          margin-right: 28px;
          margin-bottom: 24px;
        }
        .boxActive{
          background-color: $brand-color;
          color:white;
          border: 1px solid $brand-color
        }
      }
    }
  }
}
</style>

<style lang="scss">
.shoppingMall {
  .swiper-pagination-bullet {
    width: 16px;
    height: 12px;
    background: rgba($white-color, 0.6);
    border-radius: 6px;
    transition: 0.3s;
  }
  .swiper-pagination-bullet-active {
    width: 40px;
    background: rgba($white-color, 0.6);
  }
}
</style>
